import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  navOpened = false;
  user: User;

  votingActive;

  constructor(
    public auth: AuthService,
    private afs: AngularFirestore
    ) { 
      this.votingActive = this.afs.collection('extras').doc('voting').valueChanges()
    }

  ngOnInit(): void {
    this.auth.getUser().then((user: User) => {
      this.user = user;
    })
  }

  logout() {
    this.auth.signOut();
  }

}
